import React from "react";
import { Button, Modal } from "react-bootstrap";
import { DeleteWarningIcon, TrashIconOutline } from "../../ui/icons";
import { useDeleteSubscriptionModal } from "./useDeleteSubscriptionModal";

interface IProps {
  subscriptionId: string;
}

const DeleteSubscriptionModal = (props: IProps) => {
  const { subscriptionId } = props;
  const { handleDeleteButtonClick, showModel, handleClose, handleShow } =
    useDeleteSubscriptionModal(subscriptionId);

  return (
    <>
      <div onClick={handleShow}>
        <TrashIconOutline />
      </div>

      <Modal
        show={showModel}
        onHide={handleClose}
        className="modal-container"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>Delete</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete subscription?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteSubscriptionModal;
